import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useStartFreeTrialState } from 'components/FloatingStartFreeTrial/FloatingStartFreeTrial.helpers';
import Message from './components/Message';
import Style from './Styles/ContextualRoadBlock.module.scss';

const ContextualRoadBlock = ({
  account,
  backgroundImage,
  isMobile,
  isTablet,
  isTrailerUpsell,
  subscriptionPaused,
  pathOverride,
}) => {
  const {
    playback_upsellBlockHeader: headerText,
    playback_upsellBlockHeaderDesktop: headerDesktopText,
    playback_upsellBlockMessageDesktop: messageTextDesktop,
    playback_upsellBlockHeaderMobile: headerMobileText,
    playback_upsellBlockMessageMobile: messageTextMobile,
  } = window.Language;
  const messageProps = {
    theme: Style,
    isTrailerUpsell,
    account,
    subscriptionPaused,
    messageText: isTablet ? messageTextMobile : messageTextDesktop,
    pathOverride,
    header: isTablet ? headerMobileText : headerDesktopText || headerText,
  };
  const backgroundStyle = {
    background: isMobile
      ? `url(${backgroundImage}) center center / cover no-repeat`
      : `linear-gradient(180deg, rgba(0, 0, 0, 0) 50.58%, rgba(0, 0, 0, 0.36) 76.74%, rgba(0, 0, 0, 0.4) 100%), url(${backgroundImage}) center center / cover no-repeat`,
  };
  const divRef = useRef();

  useStartFreeTrialState(divRef, { rootMargin: '-80px 0px 0px 0px' });

  return (
    <>
      <div ref={divRef} className={Style.container}>
        <div className={Style.background} style={backgroundStyle} />
        <Message {...messageProps} />
      </div>
    </>
  );
};

ContextualRoadBlock.defaultProps = {
  account: null,
  backgroundImage: '',
  isTrailerUpsell: false,
  subscriptionPaused: false,
  pathOverride: null,
};

ContextualRoadBlock.propTypes = {
  account: PropTypes.shape({}),
  backgroundImage: PropTypes.string,
  isTablet: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isTrailerUpsell: PropTypes.bool,
  subscriptionPaused: PropTypes.bool,
  pathOverride: PropTypes.string,
};

export default ContextualRoadBlock;
